import script from "./help2.vue?vue&type=script&setup=true&lang=js"
export * from "./help2.vue?vue&type=script&setup=true&lang=js"

import "./help2.vue?vue&type=style&index=0&id=4c2b4999&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c2b4999"]])

export default __exports__